"use client";

import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { useState } from "react";
export default function BuyerPortalOverview() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const [mousePosition, setMousePosition] = useState({
    x: 0,
    y: 0
  });
  const handleMouseMove = (e: React.MouseEvent<HTMLDivElement>) => {
    const rect = e.currentTarget.getBoundingClientRect();
    const x = ((e.clientX - rect.left) / rect.width - 0.5) * 2;
    const y = ((e.clientY - rect.top) / rect.height - 0.5) * 2;
    setMousePosition({
      x,
      y
    });
  };
  const handleMouseLeave = () => {
    setMousePosition({
      x: 0,
      y: 0
    });
  };
  return <section id="buyer-portal-overview" ref={sectionRef} className="relative bg-background py-20 md:py-28 overflow-hidden">
      <div className="container mx-auto px-4 md:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {}
          <div className={`relative transition-all duration-[var(--duration-slow)] ${isVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-8"}`} onMouseMove={handleMouseMove} onMouseLeave={handleMouseLeave}>
            <div className="relative rounded-sm overflow-hidden shadow-medium hover:shadow-strong transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)]" style={{
            transform: `perspective(1000px) rotateY(${mousePosition.x * 1.5}deg) rotateX(${-mousePosition.y * 1.5}deg)`,
            transition: "transform 0.15s ease-out"
          }}>
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1542426/img/buyer_portal_procurement_meeting.png" alt="Professional procurement meeting showcasing digital trade interface" className="w-full h-auto object-cover" style={{
              filter: "brightness(1.03) saturate(1.05)"
            }} />
            </div>
          </div>

          {}
          <div className={`transition-all duration-[var(--duration-slow)] delay-100 ${isVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-8"}`}>
            <h2 className="font-display text-4xl md:text-5xl lg:text-6xl font-bold text-primary mb-6 tracking-tight leading-tight">
              Buyer Portal Overview
            </h2>
            <p className="text-foreground text-lg md:text-xl leading-relaxed mb-8 max-w-2xl">
              Experience seamless procurement with our advanced digital platform. Access a comprehensive network of verified suppliers, streamline your sourcing process, and make informed purchasing decisions with real-time market insights and transparent pricing.
            </p>
            <Button className="btn-primary" aria-label="Access buyer portal">
              Access Portal
            </Button>
          </div>
        </div>
      </div>

      {}
      <div className="absolute bottom-0 left-0 right-0 h-px bg-border" />
    </section>;
}